var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPartFinderNoFamilies(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 152,
    viewBox: "0 0 133 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Add Part Finder Family"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company settings - Add Part Finder Family"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1010108696"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_1467_46488)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.6094 1V9.46194",
    stroke: "#313131",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.24609 7.19922L12.2551 13.1849",
    stroke: "#313131",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M1 20.5547H9.49484",
    stroke: "#313131",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M67.1586 151.745C103.527 151.745 133.009 122.377 133.009 86.1497C133.009 49.9226 103.527 20.5547 67.1586 20.5547C30.7906 20.5547 1.30859 49.9226 1.30859 86.1497C1.30859 122.377 30.7906 151.745 67.1586 151.745Z",
    fill: "#86ABF1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M25.0962 17.6765C20.3559 17.6765 16.5156 21.5019 16.5156 26.2238V127.742C28.5936 142.292 46.8519 151.573 67.2875 151.573C87.7231 151.573 105.964 142.309 118.042 127.767V35.1554L101.524 17.668H25.0962V17.6765Z",
    fill: "white",
    stroke: "#313131",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M118.042 35.1557H101.523V17.7109L118.042 35.1557Z",
    fill: "white",
    stroke: "#313131",
    strokeLinejoin: "bevel"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M47.0101 69.5628C48.5061 69.4447 49.5977 67.8247 49.4482 65.9442C49.2986 64.0638 47.9647 62.635 46.4686 62.7531C44.9726 62.8711 43.881 64.4912 44.0305 66.3717C44.18 68.2521 45.514 69.6808 47.0101 69.5628Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M88.793 69.5583C90.2873 69.6968 91.6409 68.2864 91.8163 66.4082C91.9917 64.53 90.9226 62.8951 89.4283 62.7566C87.934 62.6181 86.5804 64.0285 86.405 65.9067C86.2296 67.7849 87.2987 69.4198 88.793 69.5583Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M40.2773 58.8153C40.2773 58.8153 46.7406 60.4121 49.4579 55.2461",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M61.8438 75.0723C62.8381 78.5049 70.9043 81.0921 74.016 75.0723",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M94.7431 58.8153C94.7431 58.8153 88.2798 60.4121 85.5625 55.2461",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_12",
    filter: "url(#filter0_f_1467_46488)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.9045 73.8924C50.1414 75.8938 46.1063 77.7261 42.8134 76.7113C39.5205 75.6965 36.928 72.0037 38.4438 70.3875C39.4055 69.3539 41.1199 70.6036 44.4128 71.6184C47.7057 72.6333 51.6676 71.8909 50.9045 73.8924Z",
    fill: "#F5889D",
    fillOpacity: 0.19
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_13",
    filter: "url(#filter1_f_1467_46488)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.0881 73.8924C85.7926 75.8938 89.5173 77.7261 92.5569 76.7113C95.5965 75.6965 97.9896 72.0037 96.5904 70.3875C95.7026 69.3539 94.1201 70.6036 91.0805 71.6184C88.0409 72.6333 84.3837 71.8909 85.0881 73.8924Z",
    fill: "#F5889D",
    fillOpacity: 0.19
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1093",
    x: 28.4297,
    y: 100.904,
    width: 59.1467,
    height: 4.2694,
    rx: 2,
    fill: "#1181E9",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1094",
    x: 28.4297,
    y: 111.15,
    width: 75.4335,
    height: 4.2694,
    rx: 2,
    fill: "#1181E9",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1095",
    x: 28.4297,
    y: 121.396,
    width: 47.1459,
    height: 4.2694,
    rx: 2,
    fill: "#1181E9",
    fillOpacity: 0.1
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1467_46488",
    x: 34,
    y: 66,
    width: 21,
    height: 15,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_1467_46488"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1467_46488",
    x: 81,
    y: 66,
    width: 20,
    height: 15,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_1467_46488"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1467_46488"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 133,
    height: 152,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartFinderNoFamilies);
export default __webpack_public_path__ + "static/media/partFinderNoFamilies.15aa0aaf651ecff4e0fb623a32122660.svg";
export { ForwardRef as ReactComponent };